<template>
  <div class="group flex items-center">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
